import { ExternalLink } from "lucide-react";
import { toast } from "sonner";
import { useCart } from "@/contexts/CartContext";
import { flyToBag } from "@/lib/flyToBag";

interface BuyButtonProps {
  gameId: string;
  title: string;
  slug: string;
  sku?: string | null;
  shopUrl?: string | null;
  price?: number | null;
  imageUrl?: string | null;
  label?: string;
  className: string;
}

/**
 * Renders "Add to Bag" as an add-to-cart action when the game has a Game Crafter SKU,
 * otherwise falls back to the plain external shop link labeled "Buy Now".
 */
const BuyButton = ({ gameId, title, slug, sku, shopUrl, price, imageUrl, label, className }: BuyButtonProps) => {
  const { addItem } = useCart();

  const buttonLabel = label || (sku ? "Add to Bag" : "Buy Now");

  if (sku) {
    return (
      <button
        type="button"
        onClick={(e) => {
          addItem({ gameId, title, slug, sku, price: price ?? null, imageUrl: imageUrl ?? null }, 1);
          flyToBag(e.currentTarget, imageUrl ?? null);
          toast.success(`${title} added to bag`, { description: "View your bag in the top right." });
        }}
        className={className}
      >
        {buttonLabel}
      </button>
    );
  }

  if (!shopUrl) return null;

  return (
    <a href={shopUrl} target="_blank" rel="noopener noreferrer" className={className}>
      {buttonLabel}
      <ExternalLink className="w-4 h-4" />
    </a>
  );
};

export default BuyButton;
